import { locationSuggestions } from "./locationSuggestions";
import { productSuggestions } from "./productSuggestions";

function searchFormSuggestions() {
    if(document.getElementById("location"))
    {
        locationSuggestions(document.getElementById("location"));
    }
            
        
    if(document.getElementById("item"))
    {
        productSuggestions(document.getElementById("item"));
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    searchFormSuggestions();
    
    // Capture any product search forms so we can redirect to a clean URL if search/location is empty
    var productForms = document.querySelectorAll("#product-search");
    if (productForms) {
        productForms.forEach(form => {
            form.addEventListener("submit", function (e) {
                e.preventDefault();

                var search = new URLSearchParams();
                var u = new URL(e.target.getAttribute("action"), window.location.origin);
                var formData = new FormData(e.target);

                formData.forEach((val, key) => val ? search.append(key, val) : null);
                u.search = search;
                window.location.href = u;
            });
        });
    }
});

export default searchFormSuggestions;